module.exports = __webpack_public_path__ + "r-v3/img/link_white.b059c187.svg";